import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { BtCheck, BtUncheck } from '../../assets/images';

const Checkbox = ({ checked, onChange, size = 20, ...props }) => {
    const theme = useTheme();

    return (
        <Box
            onClick={() => onChange(!checked)}
            sx={{ cursor: 'pointer' }}
            {...props}
        >
            {checked ? (
                <BtCheck size={size} />
            ) : (
                <BtUncheck size={size} theme={theme} />
            )}
        </Box>
    );
};

export default Checkbox;
